import api from '@/services/api';

const getPayment = (paymentId, organization, invoicesitems) => api()
  .post(`payments/${paymentId}`, {
    organization,
    invoicesitems,
  });

const findTransactionById = (id) => api()
  .get(`transactions/${id}`);

const getTransactionFromPaymentId = (id) => api()
  .post(`payments/${id}/transactions`);

const createTransactionFromPaymentId = (id) => api()
  .post(`payments/${id}/transactions`);

const paymentMethod = (companyId, body) => api()
  .post(`/companies/${companyId}/payment_methods`, body);

const getPaymentMethods = (companyId, body) => api()
  .get(`/companies/${companyId}/payment_methods`, body);

const deletePaymentMethodFromId = (companyId, id) => api()
  .delete(`/companies/${companyId}/payment_methods/${id}`);

const activatePaymentMethodFromId = (companyId, id) => api()
  .patch(`/companies/${companyId}/payment_methods/${id}/activate`);

const findPaymentPreviewById = (paymentId) => api()
  .get(`payments/${paymentId}/preview`);

export {
  getPayment,
  paymentMethod,
  getPaymentMethods,
  deletePaymentMethodFromId,
  findTransactionById,
  findPaymentPreviewById,
  getTransactionFromPaymentId,
  activatePaymentMethodFromId,
  createTransactionFromPaymentId,
};
